import { useEffect, useRef } from "react";
import {useLocation, useNavigate} from "react-router-dom"; // Pour revenir en arrière
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import {CalendarDays, MapPin} from "lucide-react";
import {formatDateToFrench, getHourFromDate} from "../utils/dateUtils.ts";
import dayjs from "dayjs";
import DashedSeparator from "../components/DashedSeparator.tsx";
import {formatWithThousandsSeparator} from "../utils/currency.ts";
import {QRCodeSVG} from "qrcode.react";

const PdfPreviewPage = () => {
    const pdfRef = useRef(null);
    const navigate = useNavigate(); // Hook pour naviguer en arrière
    const location = useLocation();

    const data = location.state
    const ticket = data?.ticket
    const currentIndex = data?.currentIndex
    const totalTickets = data?.totalTickets

    const handleDownloadPDF = async () => {
        if (!pdfRef.current) {
            console.error("Erreur : l'élément PdfPreview est introuvable !");
            return;
        }

        try {
            // Capture l'élément
            const canvas = await html2canvas(pdfRef.current, {
                scale: 2, // Améliore la qualité
                useCORS: true, // Charge les images externes
                backgroundColor: "#fff",
            } );

            // Conversion en image
            const imgData = canvas.toDataURL("image/png");

            // Génération du PDF format A4
            const pdf = new jsPDF('p', 'mm', 'a4');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();


            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`Ticket_${ticket?.code}.pdf`);

            // Retourner à la page précédente après téléchargement
            navigate(-1);
        } catch (error) {
            console.error("❌ Erreur lors du téléchargement :", error);
        }
    };

    useEffect(() => {
       handleDownloadPDF(); // Lancer automatiquement au chargement
    }, []);

    return (
        <div>
{/*
            <h2>Prévisualisation du Ticket</h2>
*/}
            <div
                style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative", // Pour positionner le footer
                }}
                ref={pdfRef}
            >
                <div
                    style={{
                        width: "300px",
                        height: "700px",
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "8px",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "160px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src={
                                ticket?.service?.events?.title === "DJIBOUTI vs TOGO"
                                    ? "/DJIBOUTI%20vs%20TOGO.jpg"
                                    : ticket?.service?.events?.title === "TOGO vs DJIBOUTI"
                                        ? "/TOGO%20vs%20DJIBOUTI.png"
                                        : ""
                            }
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderTopLeftRadius: "12px",
                                borderTopRightRadius: "12px",
                            }}
                            alt=""
                        />
                    </div>
                    <div
                        style={{
                            padding: "8px 16px",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "20px",
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                color: "#000000",
                                textAlign: "center",
                                margin: "8px 0",
                                fontWeight: "bold",
                            }}
                        >
                            {ticket?.service?.events?.title}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "4px",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "16px",
                            }}
                        >
                            <CalendarDays size={18} />
                            {formatDateToFrench(ticket?.service?.events?.eventDate)} ·{" "}
                            {dayjs(ticket?.service?.events?.eventDate).format("HH:mm")}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "4px",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "16px",
                                marginBottom: "8px",
                            }}
                        >
                            <MapPin size={18} />
                            {ticket?.service?.events?.eventPlace}
                        </div>

                        <DashedSeparator />
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "14px",
                                color: "#999999",
                            }}
                        >
                            Ticket {currentIndex + 1}/{totalTickets}
                        </p>
                        <DashedSeparator />
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "12px",
                                color: "#999999",
                                marginTop: "16px",
                            }}
                        >
                            {ticket?.service?.name}
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "12px",
                                color: "#999999",
                                marginTop: "16px",
                            }}
                        >
                            Créé le {formatDateToFrench(ticket?.createdAt)} ·{" "}
                            {getHourFromDate(ticket?.createdAt)}
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "#A1BE43",
                            }}
                        >
                            {ticket?.amount === "0"
                                ? formatWithThousandsSeparator(ticket?.amount)
                                : "Gratuit"}{" "}
                            {ticket?.amount > 1 && ticket?.currency}
                        </p>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "16px 0",
                            }}
                        >
                            <QRCodeSVG height={185} width={185} value={ticket?.codeV2} />
                            {ticket?.state === 2 && (
                                <p
                                    style={{
                                        backgroundColor: "#DC2626",
                                        color: "#ffffff",
                                        padding: "8px",
                                        borderRadius: "8px",
                                    }}
                                >
                                    Déjà scanné
                                </p>
                            )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "16px",
                                }}
                            >
                                <img
                                    style={{
                                        width: "48px",
                                        height: "48px",
                                        objectFit: "contain",
                                    }}
                                    src="/sponsors/Logo%20YAS.png"
                                    alt=""
                                />
                                <img
                                    style={{
                                        width: "48px",
                                        height: "48px",
                                        objectFit: "contain",
                                    }}
                                    src="/sponsors/Voltic%20logo.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div
                    style={{
                        position: "absolute",
                        bottom: "8px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            height: "32px",
                            color: "#777777",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        <p style={{ fontSize: "12px", color: "#4B5563" }}>Powered by</p>
                        <img
                            style={{
                                width: "48px",
                                height: "48px",
                                objectFit: "contain",
                            }}
                            src="/Semoa.png"
                            alt="Semoa"
                        />
                    </div>
                </div>*/}
            </div>

        </div>
    );
};

export default PdfPreviewPage;

